'use client'

import Image from 'next/image'
import Link from 'next/link'
import { FaMicrophone, FaPaperclip, FaPhone } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import styles from './LandingChatSecondary.module.css'

const ROLEPLAY_PHOTO = '/assets/landing-features-v2/roleplay-muse.webp'

// A static, localized illustration of chat: only the links outside it navigate.
// Keep this secondary introduction exclusive to the Create experiment treatment.
export default function LandingChatSecondary() {
  const { t } = useTranslation()

  return (
    <section
      className={styles.section}
      aria-labelledby="landing-chat-heading"
      data-landing-section="companions"
    >
      <div className={styles.panel}>
        <figure
          className={styles.preview}
          aria-label={t('landingV4_refresh_chatDemoLabel')}
        >
          <div className={styles.chatHeader}>
            <div className={styles.avatar}>
              <Image src={ROLEPLAY_PHOTO} alt="" fill sizes="40px" />
            </div>
            <div className={styles.identity}>
              <span className={styles.name}>
                {t('landingV4_refresh_chatName')}
              </span>
              <span className={styles.companion}>
                {t('landingV4_refresh_chatCompanionLabel')}
              </span>
            </div>
            <span className={styles.callIcon} aria-hidden="true">
              <FaPhone />
            </span>
          </div>
          <ol className={styles.messages}>
            <li className={styles.received}>
              <span className={styles.srOnly}>
                {t('landingV4_refresh_chatName')}:{' '}
              </span>
              {t('landingV4_refresh_chatGreeting')}
            </li>
            <li className={styles.sent}>
              <span className={styles.srOnly}>
                {t('landingV4_refresh_chatYouLabel')}:{' '}
              </span>
              {t('landingV4_refresh_chatRequest')}
            </li>
            <li className={styles.photoMessage}>
              <span className={styles.srOnly}>
                {t('landingV4_refresh_chatName')}:{' '}
              </span>
              <div className={styles.photo}>
                <Image
                  src={ROLEPLAY_PHOTO}
                  alt={t('landingV4_refresh_chatImageAlt')}
                  fill
                  sizes="(max-width: 700px) 190px, 210px"
                />
              </div>
              <p className={styles.caption}>
                {t('landingV4_refresh_chatPhotoCaption')}
              </p>
            </li>
          </ol>
          <div className={styles.composer} aria-hidden="true">
            <FaPaperclip />
            <span>{t('landingV4_refresh_chatMessagePlaceholder')}</span>
            <FaMicrophone />
          </div>
        </figure>
        <div className={styles.copy}>
          <h2 id="landing-chat-heading">{t('landingV4_chatTitle')}</h2>
          <p>{t('landingV4_chatBody')}</p>
          <div className={styles.links}>
            <Link
              href="/chat"
              className={styles.action}
              data-landing-cta="companions"
              data-landing-action="feature_roleplay"
            >
              {t('landingV4_chatAction')}
              <span aria-hidden="true">↗</span>
            </Link>
            <Link
              href="/articles/promptchan-chat-tutorial"
              className={styles.guide}
            >
              {t('landingV4_chatGuide')}
              <span aria-hidden="true">↗</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
